export const generateRandomLetter = (playedLetters = []) => {
  const allLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const availableLetters = allLetters.filter(
    (letter) => !playedLetters.includes(letter)
  );

  if (availableLetters.length === 0) {
    return null;
  }

  const randomIndex = Math.floor(Math.random() * availableLetters.length);
  return availableLetters[randomIndex];
};

export const formatTimeDisplay = (seconds) => {
  if (seconds >= 60) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return remainingSeconds > 0
      ? `${minutes}m ${remainingSeconds}s`
      : `${minutes}m`;
  }
  return `${seconds}s`;
};

export const getFinalStandings = (roomData) => {
  if (!roomData?.rounds || !roomData?.players) return [];

  const playerTotals = {};

  roomData.players.forEach((player) => {
    playerTotals[player.id] = {
      name: player.name,
      total: 0,
      roundScores: [],
    };
  });

  Object.entries(roomData.rounds).forEach(([roundNum, round]) => {
    if (round.scores) {
      Object.entries(round.scores).forEach(([userId, categoryScores]) => {
        if (playerTotals[userId]) {
          const roundTotal = categoryScores.total || 0;
          playerTotals[userId].total += roundTotal;
          playerTotals[userId].roundScores.push({
            round: roundNum,
            letter: round.letter,
            score: roundTotal,
          });
        }
      });
    }
  });

  return Object.values(playerTotals).sort((a, b) => b.total - a.total);
};

export const getGameEndedDate = (gameEndedAt) => {
  if (!gameEndedAt) return "Unknown";

  try {
    let date;

    if (gameEndedAt.toDate) {
      date = gameEndedAt.toDate();
    } else if (gameEndedAt instanceof Date) {
      date = gameEndedAt;
    } else {
      date = new Date(gameEndedAt);
    }

    if (isNaN(date.getTime())) {
      return "Unknown";
    }

    return date.toLocaleDateString();
  } catch (error) {
    console.error("Error parsing game end date:", error);
    return "Unknown";
  }
};

export const generateSpecialRounds = (enableSpecialRounds) => {
  if (!enableSpecialRounds) return [];

  const numSpecialRounds = Math.floor(Math.random() * 7) + 4;
  const maxRounds = 26;
  const availableRounds = Array.from(
    { length: maxRounds - 1 },
    (_, i) => i + 2
  );

  const earlyGameTypes = [
    { type: "first_double", weight: 12 },
    { type: "first_half", weight: 12 },
    { type: "last_double", weight: 12 },
    { type: "last_half", weight: 12 },
    { type: "time_zones", weight: 8 },
    { type: "round_equality", weight: 8 },
  ];

  const lateGameTypes = [
    { type: "chosen_one", weight: 2 },
    { type: "total_equality_average", weight: 4 },
    { type: "total_equality_random", weight: 3 },
    { type: "point_thief", weight: 6 },
    { type: "round_equality", weight: 8 },
  ];

  const earlyWeightedTypes = [];
  earlyGameTypes.forEach((special) => {
    for (let i = 0; i < special.weight; i++) {
      earlyWeightedTypes.push(special.type);
    }
  });

  const lateWeightedTypes = [];
  lateGameTypes.forEach((special) => {
    for (let i = 0; i < special.weight; i++) {
      lateWeightedTypes.push(special.type);
    }
  });

  const specialRounds = [];
  for (let i = 0; i < numSpecialRounds && availableRounds.length > 0; i++) {
    const randomIndex = Math.floor(Math.random() * availableRounds.length);
    const roundNum = availableRounds.splice(randomIndex, 1)[0];

    let randomType;
    if (roundNum <= 13) {
      randomType =
        earlyWeightedTypes[
          Math.floor(Math.random() * earlyWeightedTypes.length)
        ];
    } else {
      randomType =
        lateWeightedTypes[Math.floor(Math.random() * lateWeightedTypes.length)];
    }

    specialRounds.push({ round: roundNum, type: randomType });
  }

  specialRounds.sort((a, b) => a.round - b.round);
  return specialRounds;
};